(function(angular){
	'use strict';
	
	angular
		.module('additionalInvestmentLandingModule', 
		[
			'amountSelectModule',
			'apiModule',
			'collapseModule',
			'coreModule',
			'minInvestmentAmountModule',
			'plaidModule',
			'planModule',
			'progressIndicatorModule',
			'serviceLevelModule',
		])
		.constant('DEFAULT_ORDER_AMOUNT_OPTIONS', 
			[
				{ value: 1000, label: "$1,000", sortIndex: 1000},
				{ value: 2000, label: "$2,000", sortIndex: 2000},
				{ value: 5000, label: "$5,000", sortIndex: 5000},
				{ value: 10000, label: "$10,000", sortIndex: 10000},
				{ value: 25000, label: "$25,000", sortIndex: 25000},
				{ value: 50000, label: "$50,000", sortIndex: 50000}
			])
		.constant('MINIMUM_RIA_ORDER_AMOUNT', 100)
		.constant('OFUND_ORDER_AMOUNT_OPTIONS',
			[
				{ value: 25000, label: "$25,000", sortIndex: 25000},
				{ value: 50000, label: "$50,000", sortIndex: 50000},
				{ value: 100000, label: "$100,000", sortIndex: 100000},
				{ value: 250000, label: "$250,000", sortIndex: 250000},
				{ value: 500000, label: "$500,000", sortIndex: 500000},
				{ value: 1000000, label: "$1,000,000", sortIndex: 1000000}
			])
		.value('globalConfig', globalConfig);

})(window.angular);